import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page page52"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "content",
  style: {
    "width": "100%",
    "position": "absolute",
    "top": "7%",
    "transform": "translateY(-50%)"
  }
};
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = ["src"];
const _hoisted_11 = ["src"];
const _hoisted_12 = ["src"];
const _hoisted_13 = ["src"];
const _hoisted_14 = ["src"];
const _hoisted_15 = ["src"];
const _hoisted_16 = ["src"];
const _hoisted_17 = ["src"];
const _hoisted_18 = ["src"];
const _hoisted_19 = ["src"];
const _hoisted_20 = ["src"];
const _hoisted_21 = ["src"];

// 引入图片
import 场景展示 from '@/assets/v2/page5-1/场景展示.webp';
import 返回首页 from '@/assets/v2/page3/返回首页.webp';
import 图 from '@/assets/v2/page5-2/主图.webp';
import wenzi1 from '@/assets/v2/page5-2/文字/wenzi1.webp';
import 全屋 from '@/assets/v2/page5-2/文字/全屋.webp';
import 中央空调 from '@/assets/v2/page5-2/文字/中央空调.webp';
import 形状 from '@/assets/v2/page5-2/标识线条/形状.webp';
import 地暖 from '@/assets/v2/page5-2/文字/地暖.webp';
import 地砖 from '@/assets/v2/page5-2/文字/地砖.webp';
import 预留 from '@/assets/v2/page5-2/文字/预留.webp';
import 竖线1 from '@/assets/v2/page5-1/标识线/竖线1.webp';
import 椭圆黑 from '@/assets/v2/page5-1/标识线/椭圆黑.webp';
export default {
  __name: 'Page5-2',
  emits: ['goHome'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const gohome = () => {
      emit('goHome');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("img", {
        src: _unref(场景展示),
        alt: "场景展示",
        class: "场景展示",
        loading: "lazy"
      }, null, 8, _hoisted_2), _createElementVNode("img", {
        src: _unref(返回首页),
        alt: "返回首页",
        class: "gohomeImage",
        onClick: gohome,
        loading: "lazy"
      }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
        src: _unref(wenzi1),
        alt: "wenzi1",
        class: "wenzi1",
        loading: "lazy"
      }, null, 8, _hoisted_5), _createElementVNode("img", {
        src: _unref(竖线1),
        alt: "竖线1",
        class: "竖线1",
        loading: "lazy"
      }, null, 8, _hoisted_6), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑",
        class: "椭圆黑1",
        loading: "lazy"
      }, null, 8, _hoisted_7), _createElementVNode("img", {
        src: _unref(全屋),
        alt: "全屋",
        class: "全屋",
        loading: "lazy"
      }, null, 8, _hoisted_8), _createElementVNode("img", {
        src: _unref(中央空调),
        alt: "中央空调",
        class: "中央空调",
        loading: "lazy"
      }, null, 8, _hoisted_9), _createElementVNode("img", {
        src: _unref(形状),
        alt: "竖线2",
        class: "竖线2",
        loading: "lazy"
      }, null, 8, _hoisted_10), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑2",
        class: "椭圆黑2",
        loading: "lazy"
      }, null, 8, _hoisted_11), _createElementVNode("img", {
        src: _unref(竖线1),
        alt: "竖线3",
        class: "竖线3",
        loading: "lazy"
      }, null, 8, _hoisted_12), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑2",
        class: "椭圆黑3",
        loading: "lazy"
      }, null, 8, _hoisted_13), _createElementVNode("img", {
        src: _unref(预留),
        alt: "预留",
        class: "预留",
        loading: "lazy"
      }, null, 8, _hoisted_14), _createElementVNode("img", {
        src: _unref(图),
        alt: "图",
        class: "图",
        loading: "lazy"
      }, null, 8, _hoisted_15), _createElementVNode("img", {
        src: _unref(地暖),
        alt: "地暖",
        class: "地暖",
        loading: "lazy"
      }, null, 8, _hoisted_16), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑",
        class: "椭圆黑4",
        loading: "lazy"
      }, null, 8, _hoisted_17), _createElementVNode("img", {
        src: _unref(竖线1),
        alt: "竖线1",
        class: "竖线4",
        loading: "lazy"
      }, null, 8, _hoisted_18), _createElementVNode("img", {
        src: _unref(地砖),
        alt: "地砖",
        class: "地砖",
        loading: "lazy"
      }, null, 8, _hoisted_19), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑",
        class: "椭圆黑5",
        loading: "lazy"
      }, null, 8, _hoisted_20), _createElementVNode("img", {
        src: _unref(竖线1),
        alt: "竖线1",
        class: "竖线5",
        loading: "lazy"
      }, null, 8, _hoisted_21)])]);
    };
  }
};